import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { clientConstants, clientModels } from '..';

export const useForceAttachClientConfigSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: clientModels.IForceAttachClientConfigAll) => {
      const res = await $api.post('/v1/force-attach-client/config', data);

      return res?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([clientConstants.queryKeys.FORCE_ATTACH_CLIENT_CONFIG_ALL]);
      }
    }
  );
};
